import util from "./_util";

const {request} = util;

export default {
    // 从表单名称获取受控编号
    getSkbh(bdbh) {
        return request('bdsk/get_by_bdbh?bdbh=' + bdbh);
    }
};